import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { FileService } from 'modules/file';
import FilePlayerSection from 'modules/file/components/player/FilePlayerSection';
import FileVideoUpload from 'modules/file/components/player/FileVideoUpload';
import { isVideo } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import { UploadManager } from '@hotmart/club-files-ui';

class TabVideo extends Component {
  static propTypes = {
    entity: PropTypes.string,
    beforeSend: PropTypes.func,
    multiple: PropTypes.bool,
    medias: PropTypes.array
  };

  static defaultProps = {
    multiple: true
  };

  get item() {
    return this.props.medias ? this.props.medias[0] : {};
  }

  get isEnabled() {
    return this.item && isVideo(this.item);
  }

  render() {
    const { entity, beforeSend, multiple } = this.props;

    if (this.isEnabled) {
      return (
        <FilePlayerSection
          {...this.item}
          key={this.item.id}
          entityType={entity}
        />
      );
    } else {
      return (
        <FileVideoUpload
          entityType={entity}
          beforeSend={beforeSend}
          multiple={multiple}
        />
      );
    }
  }
}

const hocUploadManager = withRouter(({ match, entityType, ...props }) => (
  <UploadManager
    {...props}
    entity={`${entityType}_MEDIA`}
    entityId={match.params.id}
    itemsProp="medias"
    onError={FileService.handleFileException}
  >
    <TabVideo />
  </UploadManager>
));

export default hocUploadManager;
